// ----------------------------------------------------------------------------
// Component: Footer
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/newsletter-form/newsletter-form';
import 'snippets/icon/icon';
import 'snippets/menu/menu';
import 'sections/newsletter/newsletter';
import $ from 'jquery';

// Styles
import './_footer.scss';


$(function() {
    
    function switchFooterHeaders() {
        if ($(window).width() >= 1025) {
            $(".menu--default.menu--footer").find(".menu__link--heading").each(function() {
                $(this).removeClass("js--isHidden");
                $(this).siblings(".menu__link").addClass("js--isHidden");
            });
        } else {
            $(".menu--default.menu--footer").find(".menu__link--button").each(function() {
                $(this).removeClass("js--isHidden");
                $(this).siblings(".menu__link").addClass("js--isHidden");
            });
        }
    };
    
    switchFooterHeaders();
    $(window).on('resize', switchFooterHeaders);
});